/* ═══════════════════════════════════════
   Voicecan Shopify Theme — Main JS
   ═══════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {
  initAnnouncementBar();
  initNavbar();
  initMobileMenu();
  initSlideshow();
  initScrollReveal();
  initFAQ();
  initSidebarNav();
  initCounterAnimation();
  initPreorderModal();
});

/* ── Announcement Bar ── */
function initAnnouncementBar() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  const slides = bar.querySelectorAll('.announcement-bar__slide');
  const prevBtn = bar.querySelector('.announcement-bar__arrow--prev');
  const nextBtn = bar.querySelector('.announcement-bar__arrow--next');

  if (slides.length < 2) return;

  let current = 0;
  let timer = null;
  const interval = 4000; // 4 seconds auto-rotate

  function goTo(index) {
    // Add exiting class to current slide
    slides[current].classList.add('is-exiting');
    slides[current].classList.remove('is-active');

    // Calculate new index
    current = ((index % slides.length) + slides.length) % slides.length;

    // Activate new slide
    slides[current].classList.add('is-active');

    // Remove exiting class after transition
    setTimeout(() => {
      slides.forEach(slide => slide.classList.remove('is-exiting'));
    }, 400);
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function startAutoplay() {
    stopAutoplay();
    timer = setInterval(next, interval);
  }

  function stopAutoplay() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prev();
      startAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      next();
      startAutoplay();
    });
  }

  // Swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;

  bar.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  bar.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    const diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 30) {
      diff > 0 ? next() : prev();
      startAutoplay();
    }
  }, { passive: true });

  // Pause on hover (desktop)
  bar.addEventListener('mouseenter', stopAutoplay);
  bar.addEventListener('mouseleave', startAutoplay);

  // Start autoplay
  startAutoplay();
}

/* ── Navbar scroll effect ── */
function initNavbar() {
  const navbar = document.querySelector('.navbar');
  if (!navbar) return;

  const checkScroll = () => {
    if (window.scrollY > 20) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();
}

/* ── Mobile Menu ── */
function initMobileMenu() {
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const closeBtn = mobileMenu?.querySelector('.close-mobile');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    const closeMenu = () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    };

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMenu);
    });
  }
}

/* ── Scroll Reveal ── */
function initScrollReveal() {
  const elements = document.querySelectorAll('.reveal');
  if (elements.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  elements.forEach(el => observer.observe(el));
}

/* ── FAQ Accordion ── */
function initFAQ() {
  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.parentElement;
      const isSupport = item.closest('.support-faq');

      if (isSupport) {
        // Support page: independent toggle (no mutual exclusion)
        item.classList.toggle('open');
      } else {
        // Other pages: close all in same category, toggle current
        const wasOpen = item.classList.contains('open');
        item.parentElement.querySelectorAll('.faq-item').forEach(i => {
          i.classList.remove('open');
        });
        if (!wasOpen) {
          item.classList.add('open');
        }
      }
    });
  });
}

/* ── Sidebar Navigation ── */
function initSidebarNav() {
  const sidebarLinks = document.querySelectorAll('.sidebar-nav a');
  const contentSections = document.querySelectorAll('.content-section');

  if (sidebarLinks.length === 0) return;

  sidebarLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href').substring(1);

      // Update active state
      sidebarLinks.forEach(l => l.classList.remove('active'));
      link.classList.add('active');

      // Show/hide content sections
      contentSections.forEach(section => {
        if (section.id === targetId) {
          section.style.display = 'block';
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          section.style.display = 'none';
        }
      });
    });
  });

  // Check URL hash on load — show target section or first by default
  function showSection(targetId) {
    let found = false;
    contentSections.forEach(section => {
      if (section.id === targetId) {
        section.style.display = 'block';
        found = true;
      } else {
        section.style.display = 'none';
      }
    });
    if (found) {
      sidebarLinks.forEach(l => {
        l.classList.toggle('active', l.getAttribute('href') === '#' + targetId);
      });
    }
    return found;
  }

  const hash = window.location.hash.substring(1);
  if (!hash || !showSection(hash)) {
    // No hash or invalid hash — show first section
    if (contentSections.length > 0) {
      contentSections.forEach((s, i) => {
        s.style.display = i === 0 ? 'block' : 'none';
      });
    }
  } else {
    // Scroll to the target section after a brief delay for rendering
    setTimeout(() => {
      const target = document.getElementById(hash);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  // Listen for hash changes (e.g. user clicks footer links on same page)
  window.addEventListener('hashchange', () => {
    const newHash = window.location.hash.substring(1);
    if (newHash) showSection(newHash);
  });
}

/* ── Counter Animation ── */
function initCounterAnimation() {
  const counters = document.querySelectorAll('[data-count]');
  if (counters.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const target = parseFloat(el.dataset.count);
        const suffix = el.dataset.suffix || '';
        const duration = 1500;
        const start = performance.now();

        const animate = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const current = (target * eased).toFixed(1);
          el.textContent = current + suffix;
          if (progress < 1) requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(el => observer.observe(el));
}

/* ── Slideshow ── */
function initSlideshow() {
  const slideshows = document.querySelectorAll('.slideshow');
  slideshows.forEach(slideshow => {
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    const dots = slideshow.querySelectorAll('.slideshow__dot');
    const prevBtn = slideshow.querySelector('.slideshow__arrow--prev');
    const nextBtn = slideshow.querySelector('.slideshow__arrow--next');

    if (slides.length < 2) return;

    let current = 0;
    let timer = null;
    const autoplay = slideshow.dataset.autoplay === 'true';
    const interval = (parseInt(slideshow.dataset.interval, 10) || 5) * 1000;

    // Set CSS variable for dot animation duration
    slideshow.style.setProperty('--slideshow-interval', interval + 'ms');

    function goTo(index) {
      // Remove active from current
      slides[current].classList.remove('is-active');
      dots[current]?.classList.remove('is-active');

      // Reset text animations on leaving slide
      const leavingTexts = slides[current].querySelectorAll('.slideshow__heading, .slideshow__subheading, .slideshow__cta');
      leavingTexts.forEach(el => {
        el.style.animation = 'none';
        el.offsetHeight; // trigger reflow
        el.style.animation = '';
      });

      current = ((index % slides.length) + slides.length) % slides.length;

      // Add active to new
      slides[current].classList.add('is-active');
      dots[current]?.classList.add('is-active');

      // Restart dot progress animation
      const fill = dots[current]?.querySelector('.slideshow__dot-fill');
      if (fill) {
        fill.style.animation = 'none';
        fill.offsetHeight;
        fill.style.animation = '';
      }
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Event listeners
    if (prevBtn) prevBtn.addEventListener('click', () => { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { next(); startAutoplay(); });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10);
        goTo(idx);
        startAutoplay();
      });
    });

    // Swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    slideshow.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slideshow.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? next() : prev();
        startAutoplay();
      }
    }, { passive: true });

    // Pause on hover (desktop)
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);

    // Start
    startAutoplay();
  });
}

/* ── Pre-order email modal + FAB + product-module carousel ── */
function initPreorderModal() {
  const SEEN_KEY = 'voicecan_founder_modal_dismissed';
  const overlay = document.getElementById('emailModal');

  if (overlay) {
    const modalEnabled = false;
    const modalForm = document.getElementById('modalForm');
    const modalOk = document.getElementById('modalSuccess');
    const form = document.getElementById('emailForm');
    const input = document.getElementById('emailInput');
    const errorEl = document.getElementById('emailError');
    const submitBtn = document.getElementById('emailSubmit');
    let lastFocus = null;
    let autoDelayDone = false;
    let autoScrolled = window.scrollY > 120;
    let autoShown = false;

    const hasDismissedAuto = () => {
      try { return localStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return false; }
    };

    const markDismissedAuto = () => {
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    };

    const openModal = (forceOpen = false) => {
      if (!modalEnabled) return;
      if (!forceOpen && hasDismissedAuto()) return;
      if (overlay.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => { if (input) input.focus(); }, 420);
    };

    const closeModal = () => {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      markDismissedAuto();
      if (lastFocus) lastFocus.focus();
    };

    // Demo capture: store locally
    const submitEmail = (email) => {
      try {
        const saved = JSON.parse(localStorage.getItem('voicecan_waitlist') || '[]');
        saved.push({ email: email, ts: new Date().toISOString() });
        localStorage.setItem('voicecan_waitlist', JSON.stringify(saved));
      } catch (e) {}
      return new Promise((resolve) => setTimeout(resolve, 700));
    };

    const maybeAutoOpen = () => {
      if (autoShown || hasDismissedAuto()) return;
      if (autoDelayDone && autoScrolled) {
        autoShown = true;
        openModal(false);
      }
    };

    setTimeout(() => {
      autoDelayDone = true;
      maybeAutoOpen();
    }, 3000);

    window.addEventListener('scroll', () => {
      if (window.scrollY > 120) {
        autoScrolled = true;
        maybeAutoOpen();
      }
    }, { passive: true });

    // Manual triggers (FAB, hero CTA, any [data-open-modal])
    document.querySelectorAll('[data-open-modal]').forEach((b) => {
      b.addEventListener('click', () => openModal(true));
    });

    const closeBtn = document.getElementById('modalClose');
    const successClose = document.getElementById('successClose');
    const dismissBtn = document.getElementById('dismissBtn');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (successClose) successClose.addEventListener('click', closeModal);
    if (dismissBtn) dismissBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', (e) => { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
    });

    if (form && input && errorEl && submitBtn) {
      const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      input.addEventListener('input', () => {
        input.classList.remove('is-error');
        errorEl.hidden = true;
      });

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const email = input.value.trim();
        if (!EMAIL_RE.test(email)) {
          input.classList.add('is-error');
          errorEl.hidden = false;
          input.focus();
          return;
        }
        submitBtn.disabled = true;
        const label = submitBtn.querySelector('.btn__label');
        if (label) label.textContent = 'Saving…';
        try {
          await submitEmail(email);
          if (modalForm) modalForm.hidden = true;
          if (modalOk) modalOk.hidden = false;
          markDismissedAuto();
        } catch (err) {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          submitBtn.disabled = false;
          if (label) label.textContent = 'Reserve My Spot';
        }
      });
    }
  }

  // FAB: reveal after a little scroll
  const fab = document.getElementById('fab');
  if (fab) {
    const toggleFab = () => fab.classList.toggle('show', window.scrollY > 120);
    window.addEventListener('scroll', toggleFab, { passive: true });
    toggleFab();
  }

  // Product-module carousel (auto-play + dots)
  const ppSlides = document.querySelectorAll('#ppCarousel .cs-slide');
  const ppDots = document.querySelectorAll('#ppDots .cs-dot');
  if (ppSlides.length > 1) {
    let ppCur = 0;
    const ppGo = (n) => {
      ppSlides[ppCur].classList.remove('active');
      if (ppDots[ppCur]) ppDots[ppCur].classList.remove('active');
      ppCur = (n + ppSlides.length) % ppSlides.length;
      ppSlides[ppCur].classList.add('active');
      if (ppDots[ppCur]) ppDots[ppCur].classList.add('active');
    };
    ppDots.forEach((d) => {
      d.addEventListener('click', () => ppGo(parseInt(d.dataset.i, 10)));
    });
    setInterval(() => ppGo(ppCur + 1), 4000);
  }
}
